import { FormatControlId, RibbonControlId } from 'owa-ribbon-ids';

import TableMoveAboveRegular from 'owa-fluent-icons-svg/lib/icons/TableMoveAboveRegular';
import TableMoveBelowRegular from 'owa-fluent-icons-svg/lib/icons/TableMoveBelowRegular';
import TableMoveLeftRegular from 'owa-fluent-icons-svg/lib/icons/TableMoveLeftRegular';
import TableMoveRightRegular from 'owa-fluent-icons-svg/lib/icons/TableMoveRightRegular';
import AlignLeftRegular from 'owa-fluent-icons-svg/lib/icons/AlignLeftRegular';
import AlignTopRegular from 'owa-fluent-icons-svg/lib/icons/AlignTopRegular';
import TableCellsSplitRegular from 'owa-fluent-icons-svg/lib/icons/TableCellsSplitRegular';
import TableCellsMergeRegular from 'owa-fluent-icons-svg/lib/icons/TableCellsMergeRegular';
import TableDismissRegular from 'owa-fluent-icons-svg/lib/icons/TableDismissRegular';

const tableFormatTabControlIconMap: Map<RibbonControlId, string> = new Map<RibbonControlId, string>(
    [
        [FormatControlId.InsertRowAbove, TableMoveAboveRegular],
        [FormatControlId.InsertRowBelow, TableMoveBelowRegular],
        [FormatControlId.InsertColumnLeft, TableMoveLeftRegular],
        [FormatControlId.InsertColumnRight, TableMoveRightRegular],
        [FormatControlId.DeleteTableMenu, TableDismissRegular],
        [FormatControlId.TableMergeCellsMenu, TableCellsMergeRegular],
        [FormatControlId.TableSplitCellsMenu, TableCellsSplitRegular],
        [FormatControlId.TableAlignCellVerticallyMenu, AlignTopRegular],
        [FormatControlId.TableAlignCellHorizontallyMenu, AlignLeftRegular],
    ]
);

export function getTableFormatTabControlIcon(controlId: RibbonControlId): string | undefined {
    return tableFormatTabControlIconMap.has(controlId)
        ? tableFormatTabControlIconMap.get(controlId)
        : undefined;
}
